export default "__VITE_ASSET__f990931b__"